"use client";

import React from "react";

import { Banner } from "@/components/Banner";
import { Typography } from "@/components/Typography";
import { FAQScanModuleProps } from "./types";
import { TbHelpCircle } from "react-icons/tb";

import "./styles.scss";

const SupportLabel = ({ supportLabel }: { supportLabel: string }) => {
  return (
    <div className="support-label-container">
      <div className="support-label-icon">
        <TbHelpCircle />
      </div>
      <Typography
        Tag="p"
        classname="support-label"
      >
        {supportLabel}
      </Typography>
    </div>
  );
};

export const FAQScanModule = ({ data, supportLabel }: FAQScanModuleProps) => {
  const { title, subtitle, richtext } = data;

  return (
    <Banner
      big
      light
      customBgColor="neutral-50"
    >
      <div className="faq-scan-module">
        <div className="faq-scan-module__header">
          <Typography Tag="span">{title}</Typography>
          <Typography Tag="h2">{subtitle}</Typography>
        </div>
        <div className="faq-scan-module__content">
          {richtext.map((item, index) => {
            const accordionId = `faq-scan-accordion-${index}`;

            return (
              <div
                key={index}
                className="faq-scan-module__content__item"
              >
                <input
                  type="checkbox"
                  id={accordionId}
                  className="accordion-input"
                  defaultChecked={index === 0}
                />
                <label
                  className="faq-scan-module__content__item__header"
                  htmlFor={accordionId}
                >
                  <Typography Tag="h3">{item.title}</Typography>
                </label>
                <div className="faq-scan-module__content__item__body">
                  <Typography Tag={"p"}>{item.content}</Typography>
                  {item.list && (
                    <ul>
                      {item.list.map((item, index) => (
                        <li key={index}>{item.item}</li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      {supportLabel && <SupportLabel supportLabel={supportLabel} />}
    </Banner>
  );
};
